import React from "react"
import { Pane } from "components/ui"
import { Box, StackView, Text } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import { arrayOf, shape, string, func, bool, number, object } from "prop-types"
import { Link } from "@reach/router"
import { colors } from "components/shared/admin_colors"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ToggleQuestionTypeButton from "./ToggleQuestionTypeButton"

const DraggableQuestions = ({
  questions,
  basePath,
  handleDragEnd,
  group,
  signup,
  isActingStaff,
  onQuestionTypeToggle
}) => {
  const showQuestionTypeToggle = isActingStaff && group !== "registrant"

  return (
    <Pane.Body paddingBottom={0}>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, _snapshot) => (
            <>
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {questions.map((question, index) => (
                  <Draggable key={question.id} draggableId={question.id.toString()} index={index}>
                    {provided => (
                      <div ref={provided.innerRef} {...provided.draggableProps}>
                        <StackView paddingBottom={2} axis="horizontal" spacing={2}>
                          <Box {...provided.dragHandleProps}>
                            <Icon
                              style={{ color: colors.neutral_040 }}
                              symbol="general#three-horizontal-bars"
                            />
                          </Box>
                          <Link to={`${basePath}/${question.id}/edit`} css={{ flexGrow: 1 }}>
                            <Box>
                              <StackView axis="horizontal" alignment="center" spacing={1}>
                                <Text
                                  weight={question.sectionHeader ? 600 : 400}
                                  color="var(--t-text-color-default-primary)"
                                  marginBottom={0.5}
                                >
                                  {question.question}
                                </Text>
                                {question.restrictedToAdmin && (
                                  <span
                                    className="c-warning-icon"
                                    data-tooltip="Not shown on Church Center"
                                  >
                                    <Icon symbol="general#hide-eye" />
                                  </span>
                                )}
                              </StackView>
                              <StackView axis="horizontal" alignment="center" spacing={2}>
                                <Text marginBottom={0.5} color={colors.neutral_020} size={14}>
                                  {question.kindLabel}
                                </Text>
                                {question.publiclyRequired && (
                                  <Text marginBottom={0.5} color={colors.error} size={14}>
                                    Required
                                  </Text>
                                )}
                              </StackView>
                              {question.description && (
                                <Box>
                                  <Text size={14} color={colors.neutral_020}>
                                    {question.description}
                                  </Text>
                                </Box>
                              )}
                            </Box>
                          </Link>
                          {showQuestionTypeToggle && (
                            <Box textAlign="right" flexShrink={1}>
                              <ToggleQuestionTypeButton
                                signup={signup}
                                question={question}
                                group={group}
                                onQuestionTypeToggle={onQuestionTypeToggle}
                              />
                            </Box>
                          )}
                        </StackView>
                      </div>
                    )}
                  </Draggable>
                ))}
              </div>
              {provided.placeholder}
            </>
          )}
        </Droppable>
      </DragDropContext>
    </Pane.Body>
  )
}

DraggableQuestions.propTypes = {
  group: string.isRequired,
  questions: arrayOf(object),
  basePath: string,
  blankStateImageURL: string,
  questionOrderPath: string,
  navigate: func,
  signup: shape({ id: number }),
  isActingStaff: bool,
  onQuestionTypeToggle: func,
  selectionsUrl: string,
  handleDragEnd: func
}

export default DraggableQuestions
